(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["buy-buttons"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('back-in-stock-form')) {
    customElements.define(
      'back-in-stock-form',
      class BackInStockForm extends HTMLElement {
        connectedCallback() {
          this.form = this.querySelector('form');
          this.message = this.querySelector('[data-message]');

          if (!this.form) return;

          this.form.addEventListener('submit', this.onSubmit.bind(this));
        }

        onSubmit(event) {
          event.preventDefault();

          const companyId = this.dataset.companyId;
          const email = this.form.querySelector('[name="email"]')?.value;
          const variantId = this.form.querySelector('[name="variant_id"]')?.value;
          const submitButton = this.form.querySelector('[type="submit"]');

          if (!companyId) {
            this.showMessage(this.dataset.missingKeyMessage);
            return;
          }

          if (!email || !variantId) {
            this.showMessage(this.dataset.errorMessage);
            return;
          }

          submitButton?.setAttribute('disabled', 'disabled');

          const payload = {
            data: {
              type: 'back-in-stock-subscription',
              attributes: {
                profile: {
                  data: {
                    type: 'profile',
                    attributes: {
                      email,
                    },
                  },
                },
                channels: ['EMAIL'],
              },
              relationships: {
                variant: {
                  data: {
                    type: 'catalog-variant',
                    id: `$shopify:::$default:::${variantId}`,
                  },
                },
              },
            },
          };

          fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${encodeURIComponent(companyId)}`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              revision: '2024-06-15',
            },
            body: JSON.stringify(payload),
          })
            .then((response) => {
              if (!response.ok && response.status !== 202) throw new Error('Back in stock request failed');

              this.form.reset();
              this.showMessage(this.dataset.successMessage);
            })
            .catch(() => {
              this.showMessage(this.dataset.errorMessage);
            })
            .finally(() => {
              submitButton?.removeAttribute('disabled');
            });
        }

        showMessage(message) {
          if (!this.message) return;

          this.message.textContent = message || '';
          this.message.classList.toggle('back-in-stock__success', Boolean(message));
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-social-share"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-social-share')) {
    customElements.define(
      'product-social-share',
      class ProductSocialShare extends HTMLElement {
        connectedCallback() {
          this.querySelectorAll('[data-native-share]').forEach((button) => {
            button.addEventListener('click', this.share.bind(this));
          });
        }

        share(event) {
          event.preventDefault();

          const url = this.dataset.shareUrl || window.location.href;
          const title = this.dataset.shareTitle || document.title;

          if (navigator.share) {
            navigator.share({ title, url });
            return;
          }

          if (navigator.clipboard) {
            navigator.clipboard.writeText(url).then(() => this.showMessage('Link copied'));
            return;
          }

          window.prompt('Copy this link', url);
        }

        showMessage(message) {
          const messageElement = this.querySelector('.product-social-share__message');

          if (!messageElement) return;

          messageElement.textContent = message;
          window.setTimeout(() => {
            messageElement.textContent = '';
          }, 3000);
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
